$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ComposerPosSelectorView extends View
  viewTitleKey: 'select position'

  events:
    'change .js-select-list': 'changeList'
    'change .js-select-position': 'changePosition'
    'mouseenter .js-pos-results li': 'hoverPosResultsSelect'

    'click .js-select-pos-keyword': 'selectPosResult'
    'click .js-select-pos-pos': 'selectPosResult'
    'click .js-select-pos-list': 'selectPosResult'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

    if @sendGASEvent
      Analytics.sendScreenEvent
        name: 'cardComposerPositionSelectorInlineDialog'
        containers:
          list:
            id: @model?.getList()?.id
          board:
            id: @model?.getBoard()?.id
          organization:
            id: @model?.getBoard()?.getOrganization()?.id

  populateResults: (results) ->
    @data =
      filtered: true
      keywordList: results.keywordList.map (kw) =>
        value: kw
        indexString: kw
        listName: @model.get('list').get('name')
      indexList: results.indexList.map (index) =>
        value: index
        indexString: String(index)
        listName: @model.get('list').get('name')
      listList: results.listList.map (list) =>
        value: list.get('id')
        indexString: String(@model.get('index') + 1)
        listName: list.get('name')

  render: ->
    if @data
      @$el.html(
        templates.fill(
          require('app/scripts/views/templates/popover_filter_pos_results'),
          @data
        )
      )
    else
      data =
        hideBoard: true

      @$el.html(
        templates.fill(
          require('app/scripts/views/templates/move_card_controls'),
          data
        )
      )

      @updateListList()

    @

  hoverPosResultsSelect: (e) ->
    elem = $(e.target).closest('li')
    Util.selectMenuItem(@$('.js-pos-results'), 'li', elem)

  selectPosResult: (e) ->
    Util.stop(e)

    parent = $(e.target).closest('a')
    value = parent.attr('name')

    list = @model.getList()
    cardCount = list.openCards().length
    bottomPos = cardCount + 1

    if parent.hasClass('js-select-pos-keyword')
      if value == 'top'
        @model.set('index', 0)
        track('Card Composer', 'Select Position in List by Autocomplete', 'Top of List - Used "Top"')

      else if value == 'bottom'
        @model.set('index', bottomPos)
        track('Card Composer', 'Select Position in List by Autocomplete', 'Bottom of List - Used "Bottom"')

    else if parent.hasClass('js-select-pos-pos')
      @model.set('index', parseInt(value, 10) - 1)
      track('Card Composer', 'Select Position in List by Autocomplete', 'Selected Position - Used Number')

    else if parent.hasClass('js-select-pos-list')
      isBottom = cardCount == @model.get('pos')

      @model.set('list', @model.getBoard().getList(value))
      if isBottom
        @model.set('index', cardCount)
        track('Card Composer', 'Select List by Autocomplete', "Bottom")
      else
        track('Card Composer', 'Select List by Autocomplete', 'Not Bottom')

      # GAS migration cleanup: this is likely dead code
      # https://bitbucket.org/trello/web/pull-requests/5317/
      if @sendGASEvent
        Analytics.sendUIEvent
          action: 'selected'
          actionSubject: 'list'
          actionSubjectId: 'cardComposerList'
          source: 'cardComposerPositionSelectorInlineDialog'
          attributes:
            isAtTopofList: value == 'top'
            isAtBottomOfList: value == 'top'
          containers:
            list:
              id: @model?.getList()?.id
            board:
              id: @model?.getBoard()?.id
            organization:
              id: @model?.getBoard()?.getOrganization()?.id

    if parent.hasClass('js-select-pos-keyword') || parent.hasClass('js-select-pos-pos')
      if @sendGASEvent
        Analytics.sendUIEvent
          action: 'selected'
          actionSubject: 'position'
          actionSubjectId: 'cardComposerPosition'
          source: 'cardComposerPositionSelectorInlineDialog'
          attributes:
            isAtTopofList: value == 'top'
            isAtBottomOfList: value == 'top'
          containers:
            list:
              id: @model?.getList()?.id
            board:
              id: @model?.getBoard()?.id
            organization:
              id: @model?.getBoard()?.getOrganization()?.id

    PopOver.hide()

    return

  filterPos: (term) ->
    termRe = ///^#{Util.escapeForRegex(term)}///
    numRe = ///^#{Util.escapeForRegex(term)}$///

    currentListCards = @model.getList().openCards()

    idMatchNames =
      keywordList: (keyword for keyword in ['top', 'bottom'] when termRe.test(keyword))
      indexList:   (index for index in [1..currentListCards.length + 1] when numRe.test(String(index)))
      listList:    []

    for list in @model.getBoard().listList.models
      splitNames = _.compact(list.get('name').toLowerCase().split(/\s+/))
      if _.find(splitNames, (name) -> termRe.test(name))
        idMatchNames.listList.push list

    idMatchNames.hasData = !_.isEmpty(idMatchNames.keywordList) || !_.isEmpty(idMatchNames.indexList) || !_.isEmpty(idMatchNames.listList)

    return idMatchNames

  updateListList: ->
    list = @model.getList()
    idListSelected = list.id
    board = @model.getBoard()

    $selectList = @$('.js-select-list')

    $selectList.empty()

    for list in _.sortBy(board.listList.models, (list) -> list.get('pos'))

      name = list.get('name')
      desc = if list.id == idListSelected
        l('selected list', { listName: name })
      else
        name

      $option = $('<option>').val(list.id).text(desc)
      $selectList.append $option
      if list.id == idListSelected
        $option.attr('selected', 'selected')
        @$('.js-list-value').text(name)

    @updatePositionList()

  updatePositionList: ->
    $selectList = @$('.js-select-list')
    $selectPos = @$('.js-select-position')

    idListSelected = $selectList.find('option:selected').val()

    $selectPos.empty()
    list = @model.getList()

    listSelected = @model.getBoard().listList.get(idListSelected)

    cardList = list.cardList

    if @model.get('index') > cardList.length
      @model.set('index', cardList.length)

    if cardList.length == 0
      $option = $('<option>').val('0').text("1").appendTo($selectPos)
      @$('.js-pos-value').text("1")
      return

    for i in [0..cardList.length]
      desc = String(i + 1)

      $option = $('<option>').val(i).text(desc).appendTo($selectPos)

      if i == @model.get('index')
        $option.attr('selected', 'selected')

    @$('.js-pos-value').text(@model.get('index').toString())

    return

  changeList: ->
    index = @model.get('index')
    cardCount = @model.getList().openCards().length
    isBottom = cardCount == index

    listSourceId = @model?.getList()?.id
    $selectList = @$('.js-select-list')
    idListSelected = $selectList.find('option:selected').val()
    newList = @model.getBoard().getList(idListSelected)
    @model.set('list', newList)
    newCardCount = newList.openCards().length

    if isBottom
      @model.set('index', newCardCount)
      track('Card Composer', 'Change Position by Click', 'Change List - Bottom')
    else
      @model.set('index', Math.min(newCardCount, index))
      track('Card Composer', 'Change Position by Click', 'Change List - Not Bottom')

    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'moved'
        actionSubject: 'cardComposer'
        source: 'cardComposerPositionSelectorInlineDialog'
        attributes:
          isAtBottomOfList: isBottom
          listSourceId: listSourceId
        containers:
          list:
            id: @model?.getList()?.id
          board:
            id: @model?.getBoard()?.id
          organization:
            id: @model?.getBoard()?.getOrganization()?.id

    PopOver.hide()

    return

  changePosition: ->
    $selectPos = @$('.js-select-position')
    posSelected = parseInt($selectPos.find('option:selected').val(), 10)
    @model.set('index', posSelected)

    track('Card Composer', 'Change Position by Click', 'Change Position in List')

    if @sendGASEvent
      Analytics.sendUIEvent
        action: 'moved'
        actionSubject: 'cardComposer'
        source: 'cardComposerPositionSelectorInlineDialog'
        attributes:
          posSelected: posSelected
        containers:
          list:
            id: @model?.getList()?.id
          board:
            id: @model?.getBoard()?.id
          organization:
            id: @model?.getBoard()?.getOrganization()?.id

    PopOver.hide()
    return
